/**
 * Order numbers as people type them (#621).
 *
 * The store shows "#EL14319"; people paste "14319", "EL14319" or "#el14319",
 * separated by commas, spaces or new lines. One key for all of them, shared by
 * the paste box that reads the list and the API that matches it, so what the
 * screen says it did not find is exactly what the server did not find.
 */

/** Most numbers one paste is read for; more is a different job. */
export const MAX_ORDER_NUMBERS = 200;

/** "#EL14319", "el14319" and "14319" are one key: "14319". */
export function orderNumberKey(value: string): string {
  return value
    .trim()
    .replace(/^#?\s*(el)?/i, "")
    .replace(/\s+/g, "")
    .toUpperCase();
}

/** The keys in a pasted list, in the order given, each once, none blank. */
export function parseOrderNumbers(text: string): string[] {
  const seen = new Set<string>();
  for (const token of text.split(/[\s,;]+/)) {
    const key = orderNumberKey(token);
    if (key !== "") seen.add(key);
  }
  return [...seen];
}
